import type { VariantProps } from "tailwind-variants";
import { tv } from "tailwind-variants";

export const buttonVariants = tv({
    base: [
        "gap-2 tracking-wide transition-colors duration-200 cursor-pinter select-none disabled:cursor-not-allowed transition-colors duration-100",
        "font-medium ring-inset focus:outline-hidden focus:ring-2 focus:ring-blue-500 focus:ring-offset-white",
        "cursor-pointer disabled:cursor-not-allowed",
    ],
    variants: {
        theme: {
            primary: `bg-white/10 border-[0.5px] border-white/35 rounded-full button-shadow active:bg-white/20 hover:bg-white/20 disabled:opacity-30`,
            secondary: `bg-secondary-500 border-[0.5px] border-white/35 rounded-full disabled:text-white/30 active:bg-secondary-300`,
        },
        size: {
            md: "h-11 px-4 py-2 text-xs",
        },
        textSize: {
            md: "text-sm",
        },
        fullWidth: {
            true: "w-full",
        },
        content: {
            center: "flex items-center justify-center",
            between: "flex items-center justify-between",
        },
    },
    defaultVariants: {
        content: "center",
        size: "md",
        fullWidth: false,
        theme: "primary",
    },
});

export type ButtonVariantsProps = VariantProps<typeof buttonVariants>;
